<div class="container fileUploadWrapper" appFileUpload (click)="fileField.click()" (fileDropped)="upload($event)">
    <form>
        <div class="row w-100">
            <div class="col-12 center">
                <p class="title">{{title}}</p>
                <p *ngIf="subtitle && subtitle !='' " class="title">{{subtitle}}</p>
                <input type="file" name="file" #fileField (change)="upload($event.target.files)" hidden>
            </div>
        </div>
    </form>
</div>